<template>
  <div class="custome-chart-container">
    <div v-if="leftShow" class="left-pad">
      <div class="title"></div>
      <div class="content">
        <div
          class="item text-center"
          :style="{
            height: height
          }"
          v-for="(item, index) in types"
          :key="index"
        >
          <el-radio
            v-model="radioValues[index]"
            @change="handleRadioClick(index)"
          ></el-radio>
        </div>
      </div>
    </div>
    <div class="middle-pad">
      <Chart :option="option"></Chart>
    </div>
    <div v-if="rightShow" class="right-pad" :style="{ width: rightPadWidth }">
      <div class="title">
        <div class="cell" style="width: 110px">实际点数/应有点数</div>
        <div class="cell" style="width: 60px">
          完整率
        </div>
        <div
          class="operate-item cell"
          style="width: 30px"
          v-if="isOperate"
        ></div>
      </div>
      <div class="content">
        <div
          class="item"
          :style="{
            height: height
          }"
          v-for="(item, index) in types"
          :key="index"
        >
          <div class="cell" style="width: 110px">{{ item.bi }}</div>
          <div class="cell" style="width: 60px">{{ item.rate }}</div>
          <div class="operate-item cell" style="width: 30px" v-if="isOperate">
            <i class="el-icon-date" @click="handleDetailClick(item, index)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from './chart';
// import echarts from 'echarts';
import * as echarts from 'echarts';
export default {
  components: {
    Chart
  },
  props: {
    types: {
      type: Array,
      default: () => []
    },
    leftShow: {
      type: Boolean,
      default: false
    },
    rightShow: {
      type: Boolean,
      default: true
    },
    isOperate: {
      type: Boolean,
      default: true
    },
    rightPadWidth: {
      type: String,
      default: '220px'
    }
  },
  data() {
    return {
      option: {},
      radioValues: [],
      lastRadioIndex: null
    };
  },

  computed: {
    height() {
      if (!this.types.length) return 0;

      return '' + (1 / this.types.length) * 100 + '%';
    },
    reverseList() {
      return [...this.types].reverse();
    }
  },

  created() {
    this.radioValues = new Array(this.types.length).fill(false);
    this.option = this.handleOption();
  },

  watch: {
    types: {
      handler() {
        this.option = this.handleOption();
      }
    }
  },

  methods: {
    handleRadioClick(index) {
      if (this.lastRadioIndex !== null) {
        this.radioValues[this.lastRadioIndex] = false;
      }

      this.radioValues[index] = true;
      this.lastRadioIndex = index;
      this.$emit('radioClick', index);
    },
    handleDetailClick(item, index) {
      this.$emit('detailClick', { item, index });
    },
    handleOption() {
      const option = {
        animation: false,
        textStyle: {
          color: '#222233'
        },
        grid: {
          show: true,
          backgroundColor: '#bbb',
          top: '40px',
          left: '80px',
          right: '20px',
          bottom: '50px',
          width: 'auto', //图例宽度
          height: '450px' //图例高度
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#222233'
            }
          },
          // axisLabel: {
          //   show: false,
          //   textStyle: {
          //     color:  '#222233'
          //   }
          // },
          splitNumber: 5,
          splitLine: {
            show: false
          },

          min: (this.types[0] && this.types[0]._start) || 0,
          max: (this.types[0] && this.types[0]._end) || 0,
          position: 'top'
        },
        yAxis: {
          inverse: true,
          axisLine: {
            lineStyle: {
              color: '#222233'
            }
          },
          splitLine: {
            show: true
          },
          axisTick: {
            length: 1
          },
          min: 0,
          data: this.types.map(i => {
            return {
              value: i._name
            };
          }),
          axisLabel: {
            fontSize: 12
            // textStyle: {
            //   color:  '#222233'
            // }
          }
        },
        series: [
          {
            type: 'custom',
            hoverAnimation: false,
            renderItem: (params, api) => {
              var categoryIndex = api.value(0);
              var start = api.coord([api.value(1), categoryIndex]);
              var end = api.coord([api.value(2), categoryIndex]);
              var height = api.size([0, 1])[1];

              var rectShape = echarts.graphic.clipRectByRect(
                {
                  x: start[0],
                  y: start[1] - height / 2,
                  width: end[0] - start[0],
                  height: height
                },
                {
                  x: params.coordSys.x,
                  y: params.coordSys.y,
                  width: params.coordSys.width,
                  height: params.coordSys.height
                }
              );

              return (
                rectShape && {
                  type: 'rect',
                  shape: rectShape,
                  style: api.style()
                }
              );
            },
            // itemStyle: {
            //   opacity: 1
            // },
            encode: {
              x: [1, 2]
              // y: 0
            },
            data: this.types.reduce((acc, c) => {
              acc = [...acc, ...c.value];
              return acc;
            }, [])
          }
        ]
      };

      return option;
    }
  }
};
</script>

<style lang="less" scoped>
.custome-chart-container {
  display: flex;
  height: 100%;

  .left-pad {
    width: 80px;
  }

  .middle-pad {
    flex: 1;
  }

  .right-pad {
    padding-top: 10px;
  }

  .right-pad,
  .left-pad {
    // width: 300px;
    .title {
      color: #222233;
      height: 30px;
      font-size: 12px;
      display: flex;
      align-self: center;
      .cell {
        margin: 0 5px;
        display: flex;
        align-items: center;
      }
    }
    .content {
      height: 450px;
      // background-color: pink;

      .item {
        font-size: 12px;
        color: #222233;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        &.text-center {
          justify-content: center;
        }
        .cell {
          margin: 0 5px;
          display: flex;
          align-items: center;
          &.operate-item {
            i {
              font-size: 14px;
              &:hover {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
</style>
